import { ApplicationTypes, PN6Hole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  ArrowHeadType,
  detailComponent,
  dimensionIndicatorComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { bendHoleDimensionIndicatorCoordinates, scaleIndicator } from './common'

export const pn6HoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('PN6Hole')
    .attach(() => {
      return {
        title: featureLabels[PN6Hole.type],
        subtitle: '',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/pn6.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('PN6Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('PN6Hole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  attachComponent
    .withEntity('PN6Hole')
    .withComponent(dimensionIndicatorComponent, 'radius')
    .withFilter({
      navigationStates: [
        ApplicationTypes.NavigationState.Finalization,
        ApplicationTypes.NavigationState.Features,
        ApplicationTypes.NavigationState.FeatureList,
      ],
    })
    // TODO: memoEval
    .attach(s => {
      return {
        ...bendHoleDimensionIndicatorCoordinates(s, {
          startX: 0,
          endX: 0,
          startY: s.height / 2,
          endY: -s.height / 2,
          startZ: s.$plate.thickness + 0.1,
          endZ: s.$plate.thickness + 0.1,
          extrusionX: 0,
        }),
        arrowHeadType: ArrowHeadType.CONE,
        arrowHeadSize: 4,
        labelFontSize: scaleIndicator(4, 64, Math.max(s.$plate.$sizeX, s.$plate.$sizeY)),
        label: `R=${s.height / 2}`,
      }
    }),
]
